import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from "@angular/core";

@Component({
  selector: "[wall-type-1]",
  templateUrl: "./wall-type-1.component.html",
  styleUrls: ["./wall-type-1.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WallType1Component {
  height = input<number>();

  leftWallPoints = computed(() => this.getWallPoints(this.height(), "left"));
  rightWallPoints = computed(() => this.getWallPoints(this.height(), "right"));

  // Library
  private getWallPoints(baseHeight: number, wallSide: "left" | "right"): string {
    const wallData = {
      left: `M21 ${baseHeight + 15} L21 101 L152 176 L152 ${baseHeight + 90} Z`,
      right: `M152 176 L329 73 L329 ${baseHeight - 5} L152 ${baseHeight + 90} Z`,
    };

    return wallData[wallSide];
  }
}
